'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LAFooterContainer = require('./LAFooter/LAFooterContainer');

var _LAFooterContainer2 = _interopRequireDefault(_LAFooterContainer);

var _WhiteLabelFooterContainer = require('./WhiteLabelFooter/WhiteLabelFooterContainer');

var _WhiteLabelFooterContainer2 = _interopRequireDefault(_WhiteLabelFooterContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function (_PureComponent) {
    (0, _inherits3.default)(Footer, _PureComponent);

    function Footer() {
        (0, _classCallCheck3.default)(this, Footer);
        return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
    }

    (0, _createClass3.default)(Footer, [{
        key: 'render',
        value: function render() {
            var whiteLabel = this.props.whiteLabel;


            return whiteLabel ? (0, _jsx3.default)(_WhiteLabelFooterContainer2.default, {}) : (0, _jsx3.default)(_LAFooterContainer2.default, {});
        }
    }]);
    return Footer;
}(_react.PureComponent);

exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.js
// module id = z8S5
// module chunks = 60